/*global REACT_APP_IDENTITY_SERVER_BASE_URL, REACT_APP_CLIENT_ID, REACT_APP_SCOPE:true*/
import qs from "qs";
import request from "@/utils/request";
import { removeLocalStorage, setLocalStorage, getLocalStorage } from "@/utils/storage";

function setLoginData(resp) {
  let data;
  let response;
  if (resp.response) {
    data = resp.data;
    response = resp.response;
  }
  if (response?.ok) {
    setLocalStorage("dataAuth", data);
  }

  if (response) {
    return response;
  }

  return resp;
}

export async function AccountLogin(params) {
  const loginRequest = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/connect/token`, {
    method: "POST",
    body: qs.stringify({
      client_id: `${REACT_APP_CLIENT_ID}`,
      grant_type: "password",
      scope: REACT_APP_SCOPE,
      username: params.username,
      password: params.password,
    }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    getResponse: "true",
  });

  return setLoginData(loginRequest);
}

export async function AccountImpersonate(params) {
  const loginRequest = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/connect/token`, {
    method: "POST",
    body: qs.stringify({
      client_id: `${REACT_APP_CLIENT_ID}`,
      grant_type: "Impersonation",
      scope: REACT_APP_SCOPE,
      access_token: params.accessToken,
      UserId: params.userId,
    }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    getResponse: "true",
  });

  return setLoginData(loginRequest);
}

export async function revokeToken(params) {
  const revokeTokenRequest = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/connect/revocat`, {
    method: "POST",
    body: qs.stringify({
      client_id: REACT_APP_CLIENT_ID,
      token: params.token,
    }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    getResponse: "true",
  });

  removeLocalStorage("dataAuth");

  return revokeTokenRequest;
}

export async function getFakeCaptcha(mobile) {
  return request(`/api/login/captcha?mobile=${mobile}`);
}

export async function refreshToken() {
  let dataAuthGet = getLocalStorage("dataAuth");
  let refresh_token = dataAuthGet?.refresh_token;

  const refreshTokenRequest = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/connect/token`, {
    method: "POST",
    body: qs.stringify({
      client_id: `${REACT_APP_CLIENT_ID}`,
      grant_type: "refresh_token",
      scope: REACT_APP_SCOPE,
      refresh_token,
    }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    getResponse: "true",
  });
  return setLoginData(refreshTokenRequest);
}
